// extracted by mini-css-extract-plugin
module.exports = {"ordersAlert":"page_ordersAlert__3w7Zg","titleArea":"page_titleArea__29g25"};